module.exports = __webpack_public_path__ + "static/media/alexander.e63548a8.png";